import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AuthModal.css";

const AuthModal = ({ onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.pathname;

  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <button className="auth-modal-close" onClick={onClose}>&times;</button>
        <div className="auth-modal-icon">🛍️</div>
        <h2 className="auth-modal-title">Sign in to continue</h2>
        <p className="auth-modal-text">
          Please log in or create an account to add items to your bag.
        </p>
        <div className="auth-modal-actions">
          <button
            className="auth-modal-btn auth-modal-btn--primary"
            onClick={() => { onClose(); navigate("/login", { state: { from } }); }}
          >
            Log In
          </button>
          <button
            className="auth-modal-btn auth-modal-btn--secondary"
            onClick={() => { onClose(); navigate("/register", { state: { from } }); }}
          >
            Create Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
